import { render, staticRenderFns } from "./MyTastePanels.vue?vue&type=template&id=63ca296b&"
import script from "./MyTastePanels.vue?vue&type=script&lang=js&"
export * from "./MyTastePanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports